import type {PopupRef} from './Popup.js'
import t from '../../../helpers/Languages.js'

/**
 * Asks in popup whether to save the changes before closing: resolves 'save' (Opslaan), 'dontSave' (Niet opslaan) or
 * undefined when the question is closed, then the editing goes on.
 */
export default function askToSaveChanges(popup: PopupRef) {
    return popup.openChoice(t('saveChanges'), t('saveChangesBeforeClosing'), [
        {label: t('dontSave'), value: 'dontSave'},
        {label: t('save'), value: 'save'}
    ], {width: 400}) as Promise<'save' | 'dontSave' | undefined>
}
